module.exports = __webpack_public_path__ + "img/msu3-6.2859650b.png";